import {useParams} from 'react-router-dom';
import ChekinProSettings from '../ChekinProSettings';

function useGetGuestId() {
  const {id} = useParams<{id: string}>();

  return ChekinProSettings.guestId || id;
}

export {useGetGuestId};
